import { render, staticRenderFns } from "./SharedLinkComment.vue?vue&type=template&id=e702d6b6&scoped=true"
import script from "./SharedLinkComment.vue?vue&type=script&lang=ts"
export * from "./SharedLinkComment.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkComment.vue?vue&type=style&index=0&id=e702d6b6&prod&lang=scss&scoped=true"
import style1 from "./SharedLinkComment.vue?vue&type=style&index=1&id=e702d6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e702d6b6",
  null
  
)

export default component.exports